module.exports = __webpack_public_path__ + "static/media/intro-1--dark.a4a7b63e.png";